import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { Grid, GridColumn } from "@progress/kendo-react-grid";

class BalikyGrid extends Component {
    lastSelectedIndex = 0;

    selectionChange = event => {
        event.dataItem.selected = !event.dataItem.selected;
        this.forceUpdate();
    };

    rowClick = event => {
        let last = this.lastSelectedIndex;
        const current = this.props.items.findIndex(dataItem => dataItem === event.dataItem);

        if (!event.nativeEvent.shiftKey || !this.props.multiselect) {
            this.lastSelectedIndex = last = current;
        }

        if (!event.nativeEvent.ctrlKey || !this.props.multiselect) {
            this.props.items.forEach(item => (item.selected = false));
        }
        const select = !event.dataItem.selected;
        for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
            this.props.items[i].selected = select;
        }

        if (this.props.changeSelectedBalikPaleta) {
            this.props.changeSelectedBalikPaleta(this.props.items.filter(dataItem => dataItem.selected).map(a => a.idbalik));
        }

        this.forceUpdate();
    };

    render() {
        var localizationService = provideLocalizationService(this);

        return (
            <div onMouseDown={(e) => e.preventDefault() /* prevents browser text selection */}>
                <Grid
                    data={this.props.items}
                    selectedField="selected"
                    onSelectionChange={this.selectionChange}
                    onRowClick={this.rowClick}
                    pageable={this.props.pageable}
                    total={this.props.items ? this.props.items.length : 0}
                    pageSize={this.props.items ? this.props.items.length : 0}>
                    <GridColumn
                        field="ciarovyKod"
                        title={localizationService.toLanguageString("OdoslanieNeexpedovaneBalikyPalety.Grid.Balík", "Balík")}
                        width="100px"
                    />
                    <GridColumn
                        field="skladToNazov"
                        title={localizationService.toLanguageString("OdoslanieNeexpedovaneBalikyPalety.Grid.Predajňa", "Predajňa")}
                    />
                    {this.props.showParcelNumber ? (
                        <GridColumn
                            field="parcelNumber"
                            title={localizationService.toLanguageString("OdoslanieNeexpedovaneBalikyPalety.Grid.Parcel Number", "Parcel Number")}
                            width="100px"
                        />
                    ) : (
                        <React.Fragment></React.Fragment>
                    )}
                    <GridColumn
                        field="zoznamTypTovaru"
                        title={localizationService.toLanguageString("OdoslanieNeexpedovaneBalikyPalety.Grid.Typ", "Typ")}
                        width="50px"
                    />
                    <GridColumn field="pocetKs" title={localizationService.toLanguageString("OdoslanieNeexpedovaneBalikyPalety.Grid.Ks", "Ks")} width="50px" />
                    <GridColumn
                        field="datum"
                        title={localizationService.toLanguageString("OdoslanieNeexpedovaneBalikyPalety.Grid.Vytvorené", "Vytvorené")}
                        format="{0:d.M.yyyy H:mm}"
                        width="100px"
                    />
                    <GridColumn
                        field="skenovalUzivatelMeno"
                        title={localizationService.toLanguageString("OdoslanieNeexpedovaneBalikyPalety.Grid.Vytvoril", "Vytvoril")}
                        width="60px"
                    />
                </Grid>
            </div>
        );
    }
}

export default BalikyGrid;

registerForLocalization(BalikyGrid);



// WEBPACK FOOTER //
// ./src/components/views/Home/BalikyGrid.js